import React from "react";
import styled from "styled-components";

const HighlightsContainer = styled.div`
  background-color: #f8fafc;
  border-radius: 0;
  padding: 24px;
  margin: 20px 0;
  border-left: 4px solid #6ed216;
`;

const HighlightsTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #333;
  text-align: center;
`;

const HighlightsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

const HighlightItem = styled.div`
  text-align: center;
  padding: 16px;
  background-color: white;
  border-radius: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const HighlightValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #6ed216;
`;

const HighlightLabel = styled.div`
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
`;

const HighlightIcon = styled.div`
  font-size: 20px;
  margin-bottom: 8px;
`;

function CampaignHighlights({ smsData, emailData }) {
  const calculateCostPerClick = () => {
    const totalCost =
      parseFloat(smsData?.cost || 0) + parseFloat(emailData?.cost || 0);
    const totalClicks =
      parseInt(smsData?.clicks || 0) + parseInt(emailData?.clicks || 0);
    if (totalClicks > 0) {
      return (totalCost / totalClicks).toFixed(2);
    }
    return 0;
  };

  const getTotalReach = () => {
    return (
      parseInt(smsData?.delivered || 0) + parseInt(emailData?.delivered || 0)
    ).toLocaleString();
  };

  const getTotalEngagement = () => {
    const smsEng =
      parseInt(smsData?.previews || 0) + parseInt(smsData?.clicks || 0);
    const emailEng =
      parseInt(emailData?.opens || 0) + parseInt(emailData?.clicks || 0);
    return (smsEng + emailEng).toLocaleString();
  };

  const getPerformanceVsMarket = () => {
    // Calcul basé sur les benchmarks d'acquisition
    const emailOpenActual = emailData
      ? (parseInt(emailData.opens || 0) / parseInt(emailData.delivered || 1)) *
        100
      : 0;
    const smsClickActual = smsData
      ? (parseInt(smsData.clicks || 0) / parseInt(smsData.previews || 1)) * 100
      : 0;

    const emailVsMarket =
      emailOpenActual > 12 ? ((emailOpenActual - 12) / 12) * 100 : 0;
    const smsVsMarket =
      smsClickActual > 1.8 ? ((smsClickActual - 1.8) / 1.8) * 100 : 0;

    return Math.max(emailVsMarket, smsVsMarket).toFixed(0);
  };

  return (
    <HighlightsContainer>
      <HighlightsTitle>
        Résultats de Votre Campagne d'Acquisition
      </HighlightsTitle>
      <HighlightsGrid>
        <HighlightItem>
          <HighlightIcon>💫</HighlightIcon>
          <HighlightValue>{getTotalEngagement()}</HighlightValue>
          <HighlightLabel>Interactions Générées</HighlightLabel>
        </HighlightItem>
        <HighlightItem>
          <HighlightIcon>💰</HighlightIcon>
          <HighlightValue>{calculateCostPerClick()}€</HighlightValue>
          <HighlightLabel>Coût par Clic</HighlightLabel>
        </HighlightItem>
      </HighlightsGrid>
    </HighlightsContainer>
  );
}

export default CampaignHighlights;
